import {
  useLayoutEffect,
  useRef,
  useState,
  type VideoHTMLAttributes,
} from "react";
import { EmbedContainer } from "./EmbedContainer.tsx";

export const BaseVideo = ({
  videoClassName,
  onLoad,
  src,
  className,
  ...rest
}: Omit<VideoHTMLAttributes<HTMLVideoElement>, "src"> & {
  src?: string | null;
  videoClassName?: string;
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const ref = useRef<HTMLVideoElement>(null);
  useLayoutEffect(() => {
    if (ref.current?.onloadeddata) setIsLoaded(true);
  }, [setIsLoaded]);

  return (
    <EmbedContainer className={className} isLoaded={isLoaded}>
      <video
        ref={ref}
        src={src ?? undefined}
        className={videoClassName}
        preload="auto"
        onLoadedData={(event) => {
          setIsLoaded(true);
          onLoad?.(event);
        }}
        {...rest}
      />
    </EmbedContainer>
  );
};
